import initNavigation from "./modules/navigation";
import initSiteHeader from "./modules/site-header";

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initSiteHeader();
});
